import React from "react";
import ReactDOM from "react-dom";
import ContactAdvertiserModal from './contact_advertiser_modal';
import Sendgiftermodal from './send_gift_modal';
import Loginmodal from './login';
import UpdateCVApplyForJobModal from './update-cv-apply-job';
import Addrating from './add_rate';
class userActions {
    cardDOM = null;
    _advert_id = null;
    _userimge = null;
    _call = null;
    _apply = null;
    _chat = null;
    _gift = null;
    _fav = null;
    _rate = null;
    auth_token = null;
    alert_action = null;
    login_modal = null;
    _ads_title = null;
    _apply_method = null;
    _data_user_id = null;
    constructor(cardDom) {
        this.cardDOM = cardDom;
        this._ads_title = cardDom.getAttribute('ads-title')
        this._advert_id = cardDom.getAttribute('advert-id');
        this._apply_method = cardDom.getAttribute('apply_method');

        const userimge = cardDom.querySelector('.userimage');

        if (userimge) {
            this._userimge = userimge.getAttribute('data-src');
        }
        
        this.alert_action = cardDom.querySelector(".search404alert");
        this.login_modal = cardDom.querySelector(".login_modal");
        // action buttons
        this._apply = cardDom.querySelector('._apply');
        this._call = cardDom.querySelector('._call');
        this._chat = cardDom.querySelector('._chat');
        this._gift = cardDom.querySelector('._gift');
        this._fav = cardDom.querySelector('._fav');
        this._rate = cardDom.querySelector('._rate');
        if(this._rate){
            this._data_user_id = this._rate.getAttribute('data-user_id');
        }
        // attach event to action buttons
        if (this.login_modal) { this.login_modal.addEventListener('click', (ev) => this.showLoginModal(ev)); }
        if (this.alert_action) { this.alert_action.addEventListener('click', (ev) => this.Addalert(ev)); }
        if (this._apply) { this._apply.addEventListener('click', (ev) => this.applyToJob(ev)); }
        if (this._call) { this._call.addEventListener('click', (ev) => this.contactAdvertiser(ev)); }
        if (this._chat) { this._chat.addEventListener('click', (ev) => this.startChat(ev)); }
        if (this._gift) { this._gift.addEventListener('click', (ev) => this.sendAsGift(ev)); }
        if (this._fav) { this._fav.addEventListener('click', (ev) => this.makeFavorite(this._fav)); }
        if (this._rate){this._rate.addEventListener('click',(ev)=>this.addRate(ev));}
    }
    contactAdvertiser(ev) {

        const apply_method = ev.target.getAttribute("contact_method");

        let modalElement = document.querySelector('#createAdvertModal');

        __gaTracker('send', 'event', {
            eventCategory: 'Show Contact Details',
            eventAction: 'click',
            eventLabel: window.location.href
        });

        __gaTracker('send', 'event', {
            eventCategory: 'Card Action',
            eventAction: 'Contact Advertiser',
            eventLabel: window.location.href
        });

        if (modalElement == null) {
            let element = document.createElement('div')
            element.setAttribute('id', 'createAdvertModal');
            document.body.appendChild(element);
            modalElement = document.querySelector('#createAdvertModal')
        }

        ReactDOM.render(<ContactAdvertiserModal 
            advert_id={this._advert_id} 
            _userimge={this._userimge} 
            ads_title={this._ads_title} 
            apply_method={this._apply_method || apply_method} 
            />, modalElement
        );
    }
    Addalert() {
        this.auth_token = USER_AUTH;
        if (!this.auth_token) {
            return this.showLoginModal();
        }
    }
    sendAsGift() {
        this.auth_token = USER_AUTH;
        let modalElement = document.querySelector('#createGiftModal');

        __gaTracker('send', 'event', {
            eventCategory: 'Card Action',
            eventAction: 'Send Gift',
            eventLabel: window.location.href
        });

        if (modalElement == null) {
            let element = document.createElement('div')
            element.setAttribute('id', 'createGiftModal');
            document.body.appendChild(element);
            modalElement = document.querySelector('#createGiftModal')
        }
        ReactDOM.render(<Sendgiftermodal advert_id={this._advert_id} />, modalElement);
    }
    addRate(ev){
        let modalElement = document.querySelector('#rating-adverrister');
        this.auth_token = USER_AUTH;
        if (!this.auth_token) {
            return this.showLoginModal();
        }
        let overlay = document.querySelector(".overlay");
        let rateAdvertiser = document.querySelector(".rateAdvertiser");
        let _closeNewUserModal = document.querySelector("#closeNewUserModal-rateAdvertiser");
        overlay.classList.add('overlay-open')
        rateAdvertiser.classList.add('post-modal-open');
        _closeNewUserModal.addEventListener('click',function(){
            overlay.classList.remove('overlay-open')
            rateAdvertiser.classList.remove('post-modal-open');
        })
        ReactDOM.render(<Addrating 
            data_user_id={this._data_user_id}
            />, modalElement
        );
    }
    makeFavorite(target) {
        this.auth_token = USER_AUTH;
        const isAdd = target.classList.contains('--add');
        const isRemove = target.classList.contains('--remove');
        const image = target.querySelector('img');

        __gaTracker('send', 'event', {
            eventCategory: 'Card Action',
            eventAction: 'Make Favorite',
            eventLabel: window.location.href
        });

        if (!this.auth_token) {
            return this.showLoginModal();
        }

        if (isAdd) {
            const url = new URL(`${BASE.url}adverts/add-to-shortlist`);
            url.searchParams.append('advert_id', this._advert_id);

            __gaTracker('send', 'event', {
                eventCategory: 'Card Action',
                eventAction: 'add Favorite',
                eventLabel: window.location.href
            });

            fetch(url, { method: 'post' })
                .then(res => res.json()).then(res => {
                    image.setAttribute('src', `${BASE.urls}/v4/image/remove-from-fav.svg`);
                    target.classList.remove('--add');
                    target.classList.add('--remove');
                });
        }

        if (isRemove) {
            const url = new URL(`${BASE.url}adverts/delete-shortlist-By-Advert-Id/${this._advert_id}`);
            url.searchParams.append('advert_id', this._advert_id);

            __gaTracker('send', 'event', {
                eventCategory: 'Card Action',
                eventAction: 'Remove Favorite',
                eventLabel: window.location.href
            });
            fetch(url, { method: 'get' })
                .then(res => res.json()).then(res => {
                    image.setAttribute('src', `${BASE.urls}/v4/image/Add-To-Fav.svg`);
                    target.classList.remove('--remove');
                    target.classList.add('--add');
                });
                setTimeout(function(){
                    window.location.reload();
                },2000)

        }
    }

    startChat() {
        this.auth_token = USER_AUTH;

        __gaTracker('send', 'event', {
            eventCategory: 'Card Action',
            eventAction: 'Start Chat',
            eventLabel: window.location.href
        });

        if (!this.auth_token) {
            return this.showLoginModal();
        }
    }

    applyToJob(ev) {
        this.auth_token = USER_AUTH;

        __gaTracker('send', 'event', {
            eventCategory: 'Card Action',
            eventAction: 'Apply to Job',
            eventLabel: window.location.href
        });

        if (!this.auth_token) {
            return this.showApplyToJobModal();
        }

        return this.applyToJobModal(ev, this._advert_id);
    }

    applyToJobModal(ev, advert_id) {
        window.open(`${BASE.url}adverts/applyForJob?ads_id=${advert_id}`);
    }

    showLoginModal(next_callback) {
        let modalElement = document.querySelector('#loginModal');
        if (modalElement == null) {
            let element = document.createElement('div')
            element.setAttribute('id', 'loginModal');
            document.body.appendChild(element);
            modalElement = document.querySelector('#loginModal')
        }
        ReactDOM.render(<Loginmodal next_callback={next_callback} />, modalElement);
    }

    showApplyToJobModal() {
        let modalElement = document.querySelector('#loginModal');

        __gaTracker('send', 'event', {
            eventCategory: 'Card Action',
            eventAction: 'Guest Apply to Job',
            eventLabel: window.location.href
        });

        if (modalElement == null) {
            let element = document.createElement('div')
            element.setAttribute('id', 'loginModal');
            document.body.appendChild(element);
            modalElement = document.querySelector('#loginModal')
        }
        
        ReactDOM.render(<UpdateCVApplyForJobModal advert_id={this._advert_id} />, modalElement);
    }
}

export default function cardsController() {
    const cardsDom = document.querySelectorAll('.adsoug-card');
    if (cardsDom != null && cardsDom.length != 0) {
        cardsDom.forEach(item => new userActions(item));
    }
    
}